import React, {useState, useEffect} from "react"
import {useNavigate} from "react-router-dom"
import useAuth from "auth/useAuth"
import Spinner from "components/Spinner"
import "styles/fields.css"
import "./NewRescuerPage.css"

export default function NewRescuer(props) {

    const [lastId, setLastId] = useState('')
    const [username, setUsername] = useState('')
    const [gssId, setGssId] = useState('')
    const [changeGssId, setChangeGssId] = useState(false)
    const [givenName, setGivenName] = useState('')
    const [familyName, setFamilyName] = useState('')
    const [email, setEmail] = useState('')
    const {auth, API, admin} = useAuth()
    const navigate = useNavigate()


    const create = () => {
        if (!username) {
            alert("Nije uneto korisničko ime")
            return
        }
        if (!givenName) {
            alert("Nije uneto ime")
            return
        }
        if (!email) {
            alert("Nije uneta email adresa")
            return
        }
    
    
        const rescuer = {
            'username': username,
            'gss_id': gssId,
            'given_name': givenName,
            'family_name': familyName,
            'email': email
        }
        auth(API.rescuersPost, {}, rescuer).then(response => {
            console.log(response)
            navigate(`/rescuer/${username}`)
        })
    }

    useEffect(() => {
        auth(API.adminInfoGet, {}).then(response => {
            console.log("INFO", response)
            setLastId(response.data.max_username)
            setUsername(response.data.max_username+1)
            setGssId(response.data.max_username+1)
        });
    }, [API.adminInfoGet, auth])
    
    

    return <div className="container-fluid white shadow" id="new-rescuer">        
    
        <section className="white">
            <h2>Novi spasilac</h2>        
            <div>Ovo je najviši GSS ID u bazi: {lastId ? lastId : <Spinner/>}</div>
        </section>
        
        <section className="white">
            <h3>Korisničko ime</h3>
            <p>
                Ovo je korisničko ime. To je u 99% slučajeva isto što i GSS broj (za spasioce su korisničko ime i GSS broj isti).
                Ako nema posebnog razloga da se menja, najbolje je ostaviti predloženi broj kao username za spasioca za kog se pravi nalog.
            </p>
            
            <p><strong>Korisničko ime se NE MOŽE naknadno menjati.</strong></p>
            
            <input type="text" className="username" value={username} placeholder="Korisničko ime..." onChange={e => setUsername(e.target.value)}/>
        </section>
        
        <section className="white">
            <h3>GSS ID</h3>
            <p>
                Ovo sledeće je GSS ID. Ako se pravi nalog za spasioca, treba da bude isti kao korisničko ime (gore).
                To uključuje i tečajce, jer to što je nekome dodeljen GSS broj ne znači da je on automatski licencirani spasilac.
            </p>
                        
            <div id="gss-id-box">
                <span>GSS ID:&nbsp;</span>
                {changeGssId ? <input type="text" className="username" value={gssId} placeholder="GSS ID..." onChange={e => setGssId(e.target.value)}/>
                             : <><span>{gssId}</span><button className="btn btn-light btn-sm" onClick={e => setChangeGssId(true)}>Promeni</button></>
                }       
            </div>     
        </section>
        
        <section className="white">
            <h3>Lični podaci</h3>
            <p>Samo najvažniji. Ostali podaci će biti na sledećoj strani.</p>
            
            <div className="fields" id="fields">
                <label htmlFor="given_name">Ime</label>
                <input id="given_name" type="text" value={givenName} placeholder="Ime..." onChange={e => setGivenName(e.target.value)}/>
                
                <label htmlFor="family_name">Prezime</label>
                <input id="family_name" type="text" value={familyName} placeholder="Prezime..." onChange={e => setFamilyName(e.target.value)}/>
                
                <label htmlFor="email">E-mail adresa</label>
                <input id="email" type="text" value={email} placeholder="E-mail..." onChange={e => setEmail(e.target.value)}/>
            
                <button className="btn btn-primary btn-lg" onClick={create}>Napravi nalog</button>
            </div>
        </section>
         
        
    </div>

}